import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let question_id = useDataValue({
    viewPath: props.viewPath,
    context: 'imageCaptureQuestion',
    path: 'id',
  })

  let questions = useDataValue({
    viewPath: props.viewPath,
    context: 'imageCapture',
    path: 'questions',
  })

  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'imageCaptureSelected',
  })

  return function onClick() {
    change(next => {
      let prev_question_index =
        questions.findIndex(item => item.id === question_id) - 1
      if (prev_question_index >= 0) {
        next.current_question_id = questions[prev_question_index].id
      }
    })
  }
}
